import React from 'react'
import classnames from 'classnames'

const WarningDot = ({ className }) => (
  <div className={classnames('inline-block w-3 h-3 bg-blueViolet rounded-full', className)} />
)

export default WarningDot
